import { AnimatePresence, motion } from "framer-motion";
import type { ReactNode } from "react";
import { ProgressBar } from "./ProgressBar";

export type QuestionFrameProps = {
  index: number;
  total: number;
  direction: 1 | -1;
  canBack: boolean;
  canNext: boolean;
  isLast: boolean;
  onBack: () => void;
  onNext: () => void;
  children: ReactNode;
};

export function QuestionFrame({
  index,
  total,
  direction,
  canBack,
  canNext,
  isLast,
  onBack,
  onNext,
  children,
}: QuestionFrameProps) {
  return (
    <div className="flex min-h-[80vh] flex-col gap-8">
      <ProgressBar current={index} total={total} />

      <form
        className="flex flex-1 flex-col gap-8"
        onSubmit={(e) => {
          e.preventDefault();
          if (canNext) onNext();
        }}
      >
        <div className="relative flex-1 overflow-hidden">
          <AnimatePresence mode="wait" initial={false} custom={direction}>
            <motion.div
              key={index}
              custom={direction}
              initial={{ x: direction === 1 ? 60 : -60, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: direction === 1 ? -60 : 60, opacity: 0 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              className="w-full"
            >
              {children}
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-between gap-3 border-t border-border pt-6">
          <button
            type="button"
            onClick={onBack}
            disabled={!canBack}
            className="inline-flex items-center gap-2 rounded-input px-4 py-2 text-sm text-fg-muted transition hover:text-fg disabled:cursor-not-allowed disabled:opacity-30"
          >
            ← Zurück
          </button>
          <button
            type="submit"
            disabled={!canNext}
            className="inline-flex items-center gap-2 rounded-input bg-accent px-5 py-2.5 text-sm font-medium text-accent-fg transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-30"
          >
            {isLast ? "Abschicken" : "Weiter"} →
          </button>
        </div>
      </form>
    </div>
  );
}
